import {
  Layout,
  Typography,
  Table,
  Input,
  Image,
  Pagination,
  PaginationProps,
  Space,
  notification,
  Button,
} from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { LoadingSpin } from "../../../components/common/Loading";
import { LPPAXIOS } from "../../../framework/api/core.api";
import { LPPUrls } from "../../../LPPUrls";
import { Category } from "./Category";
import MDHeader from "../../../components/common/Header";
import { formatCurrency } from "../../../utils/NumberUtil";
import { dayConvert } from "../../../utils/timeConverter";
import {
  filterNonEmptyProperties,
  paramsFilter,
} from "../../../utils/ParamsFilter";
import axios from "axios";

const { Content } = Layout;
const { Title } = Typography;

export interface GETPRODUCTLISTTYPE {
  id: number;
  name: string;
  price: number;
  discounted_price: number;
  thumbnail: string[];
  createdAt: string;
  stock: number;
  sales_volume: number;
  isBanner: boolean;
  category: string;
  recommend: boolean;
  categoryId: number;
}

interface GETDATATYPE {
  data: GETPRODUCTLISTTYPE[];
  total: number;
}
const PERPAGE_CONSTANT = 10;

export const TablePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const search = params.get("search");
  const sort = params.get("sort");
  const order = params.get("order");
  const categoryId =
    params.get("categoryId") === null ? null : Number(params.get("categoryId"));
  const type = params.get("type") ?? null;

  const [currentPage, setCurrentPage] = useState(
    Number(params.get("start") ?? 1)
  );
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);

  const [data, setData] = useState<GETPRODUCTLISTTYPE[]>([]);
  const [api, contextHolder] = notification.useNotification();

  const clubListColumn: ColumnsType<GETPRODUCTLISTTYPE> = [
    {
      title: "연번",
      dataIndex: "operation",
      render: (_, record, index) =>
        `${(currentPage - 1) * PERPAGE_CONSTANT + (index + 1)}`,
    },
    {
      title: "대표이미지",
      width: 100,
      ellipsis: true,
      dataIndex: "thumbnail",
      render: (_, record) => (
        <Image
          src={`${process.env.REACT_APP_IMG_ENDPOINT}/${record.thumbnail[0]}`}
          width={100}
          height={100}
          alt="product_thumbnail"
          className="object-cover"
          fallback="data:image/png;base64,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"
        />
      ),
    },
    {
      title: "상품명",
      dataIndex: "name",
      width: 200,
      sorter: true,
      defaultSortOrder:
        sort === "name" ? (order === "ASC" ? "ascend" : "descend") : null,
    },
    {
      title: "카테고리",
      filters: categories.map((item, index) => {
        return {
          text: item.name,
          value: item.id,
        };
      }),
      align: "center",
      filterMultiple: false,
      defaultFilteredValue: categoryId === null ? [] : [categoryId],
      dataIndex: "categoryId",
      ellipsis: true,
      render: (_, record) => record.category,
    },
    {
      title: "판매가",
      sorter: true,
      defaultSortOrder:
        sort === "price" ? (order === "ASC" ? "ascend" : "descend") : null,
      dataIndex: "price",
      align: "right",
      render: (price) => formatCurrency(price),
    },
    {
      title: "할인된 판매가",
      dataIndex: "discounted_price",
      align: "right",
      render: (discounted_price) => formatCurrency(discounted_price),
    },

    {
      title: "재고",
      dataIndex: "stock",
      align: "right",
      render: (stock) =>
        stock === 0 ? (
          <Typography.Text type="danger" strong>
            품절
          </Typography.Text>
        ) : (
          formatCurrency(stock)
        ),
    },
    {
      title: "누적 판매량",
      dataIndex: "sales_volume",
      align: "right",
      render: (sales_volume) => formatCurrency(sales_volume),
    },

    {
      title: "등록일",
      sorter: true,
      defaultSortOrder:
        sort === "createdAt" ? (order === "ASC" ? "ascend" : "descend") : null,
      dataIndex: "createdAt",
      render: (createdAt) => dayConvert(createdAt),
    },
    {
      title: "상품 필터",
      dataIndex: "recommend",
      filters: [
        {
          text: "추천상품",
          value: "recommend",
        },
        {
          text: "인기상품",
          value: "popular",
        },
      ],
      filterMultiple: false,
      defaultFilteredValue: type === null ? [] : [type],
      render: (recommend) => {
        return recommend ? "추천상품" : "";
      },
    },
    {
      title: "알림발송",
      dataIndex: "id",
      render: (id) => (
        <Button type="primary" onClick={() => onClickFCM(id)}>
          알림발송
        </Button>
      ),
    },
    {
      title: "",
      dataIndex: "id",
      render: (id) => (
        <Space>
          <Link
            to={LPPUrls.Admin.Products.Detail.url(id)}
            className="font-medium"
          >
            상세 페이지
          </Link>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);

    console.log("search::::", search);
    LPPAXIOS.get<GETDATATYPE>(
      "/admin/product" +
        paramsFilter({
          search: search,
          categoryId: categoryId,
          sort: sort,
          order: order,
          type: type,
          start: currentPage,
          perPage: PERPAGE_CONSTANT,
        })
    )
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.total);
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          api.error({
            message: `${error.response?.data.message || error.response?.data}`,
            // description: error.response?.data.message,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [currentPage, api, search, order, sort, categoryId, type]);

  useEffect(() => {
    LPPAXIOS.get<Category[]>("/admin/category")
      .then((resolve) => {
        setCategories(resolve.data);
      })
      .catch(function (error) {
        if (axios.isAxiosError(error)) {
          api.error({
            message: `${error.response?.data.message || error.response?.data}`,
            // description: error.response?.data.message,
          });
        }
      });
  }, []);

  const onClickFCM = (id: number) => {
    LPPAXIOS.get(`/admin/fcm/product/${id}`)
      .then((resolve) => {
        api.success({ message: "알림 발송 완료" });
      })
      .catch(function (error) {
        if (axios.isAxiosError(error)) {
          api.error({
            message: `${error.response?.data.message || error.response?.data}`,
            // description: error.response?.data.message,
          });
        }
      });
  };

  const handleOnSearchFilter = (value: string) => {
    navigate(
      LPPUrls.Admin.Products.Main.url2(
        paramsFilter({
          search: value,
          categoryId: categoryId,
          sort: sort,
          order: order,
          type: type,
          start: 1,
          perPage: PERPAGE_CONSTANT,
        })
      )
    );
    setCurrentPage(1);
  };
  const handleOnChangePage: PaginationProps["onChange"] = (page) => {
    navigate(
      LPPUrls.Admin.Products.Main.url2(
        paramsFilter({
          search: search,
          categoryId: categoryId,
          sort: sort,
          order: order,
          type: type,
          start: page,
          perPage: PERPAGE_CONSTANT,
        })
      )
    );
    setCurrentPage(page);
  };

  const handleTableChange = (value: any, filter: any, sorter: any) => {
    let order =
      sorter.order === null ? null : sorter.order === "ascend" ? "ASC" : "DESC";
    let sort = sorter.field ?? null;
    let result = filterNonEmptyProperties(filter);
    console.log(result);
    handleChangeSort(sort, order, result);
  };
  const handleChangeSort = (
    sort: null | string,
    order: null | string,
    result: { [key: string]: string | null }
  ) => {
    console.log(result.recommend);
    navigate(
      LPPUrls.Admin.Products.Main.url2(
        paramsFilter({
          search: search,
          sort: sort,
          order: order,
          start: currentPage,
          perPage: PERPAGE_CONSTANT,
          type: result.recommend === undefined ? null : result.recommend,
          ...result,
        })
      )
    );
    setCurrentPage(currentPage);
  };

  return (
    <>
      <LoadingSpin loading={loading} />
      <MDHeader>
        <Title level={4}>상품</Title>
      </MDHeader>

      <Content className="m-6 bg-white">
        <Table
          pagination={false}
          rowKey={(render) => render.id}
          scroll={{ x: "max-content" }}
          dataSource={data}
          columns={clubListColumn}
          onChange={(val: any, filter: any, sorter: any, extra: any) => {
            handleTableChange(val, filter, sorter);
          }}
          title={() => (
            <Input.Search
              defaultValue={search ?? ""}
              style={{ width: 200 }}
              placeholder="상품명을 검색하세요"
              onSearch={handleOnSearchFilter}
            />
          )}
          footer={() => (
            <div className="flex justify-end">
              <Pagination
                current={currentPage}
                onChange={handleOnChangePage}
                pageSize={PERPAGE_CONSTANT}
                total={total}
                showSizeChanger={false}
              />
            </div>
          )}
        />
      </Content>
      {contextHolder}
    </>
  );
};
